/**
 * Created by dreamc_t on 2017/5/22.
 */
import './adMoney.scss';
import tmpl from './adMoney.ejs';
import Events from 'f.core.event';
import Native from 'f.component.native';

class AdMoney {
    constructor(options, showCount, hideCount) {
        this.showCount = showCount;
        this.hideCount = hideCount;
        this.options = options;
        this.init();
    }

    init() {
        this.show_timer = null;
        this.hide_timer = null;
        this.time_show = 0;//红包出现倒计时
        this.time_hide = 0;//红包隐藏倒计时
        this.hasShow = false;//默认红包未出现过
        this.hasHide = false;//默认红包出现后未隐藏
        this.formatData();
        this.initDom();
        this.initEvent();

        // this.sendCount(this.pvurl);
    }

    initDom() {
        this.el = $(tmpl());
        this.imageEl = this.el[0].querySelector('.c-image-money');
        this.closeEl = this.el[0].querySelector('.close');
        let parentNode = document.querySelector('body');
        parentNode.appendChild(this.el[0]);
        this.showCountDown();

    }

    initEvent() {
        // let _this = this;
        this.imageEl.addEventListener('touchend', (e) => {
            this.sendStatToApp('click');
            this.trigger('money_ad', this.url);
            // this.el.hide();
            e.preventDefault(); //阻止300ms后的click事件
        }, false);

        this.closeEl.addEventListener('touchend', (e) => {
            this.el.hide();
            e.preventDefault();//阻止300ms后的click事件
            return false;
        }, false);


    }

    //红包出现
    enter() {
        this.el.removeClass('animated slideInDown');


        this.el.show().addClass('ad-animated ad-slideInDown ad-slideIn');

        setTimeout(() => {
            this.el.removeClass('ad-animated ad-slideInDown')
        }, 1000);

        this.hideCountDown();

    }

    //发送统计
    sendCount(urlArr) {
        urlArr.map((item) => {
            let image = new Image();
            image.src = item;
        })
    }

    // '#adinfo#ainfo=10018600:100186003610:piclive_104314$first=yes'

    sendStatToApp(type) {
        if (type == 'click') {
            let loc = this.adPositionId;
            let id = this.adId;
            this.trigger('adclick', {loc, id});
        } else {
            let ainfo = this.adPositionId + ':' + this.adId;
            this.trigger('adinfo', {ainfo});
        }
    }

    //格式化数据
    formatData() {
        this.adPositionId = this.options.adPositionId;
        this.pvurl = this.options.adMaterials[0].adAction.pvurl;
        this.url = this.options.adMaterials[0].adAction.url;
        this.duration = this.options.adMaterials[0].duration || this.hideCount;
        this.image = this.options.adMaterials[0].imageURL;
        this.showIcon = this.options.adMaterials[0].icon.showIcon;
        this.adId = this.options.adMaterials[0].adId;
    }

    //设置隐藏倒计时
    hideCountDown() {
        if(this.hide_timer != null) {
            this.time_hide -= 4;
            return
        }
        this.hide_timer = setInterval(() => {
            let seconds = this.duration;
            console.log(`隐藏红包倒计时=============>${seconds - this.time_hide}`)
            // console.log('红包隐藏了!',this.time_hide);
            if (this.time_hide >= seconds) {
                console.log('正在隐藏红包');
                this.el.hide();
                this.hasHide = true;//红包出现后隐藏
                clearInterval(this.hide_timer);
                this.hide_timer = null;
            }
            this.time_hide++;
        }, 1000);
    }

    // 清除隐藏倒计时
    clearHideCountDown() {
        clearInterval(this.hide_timer);
        this.hide_timer = null;
    }

    // 清除出现倒计时
    clearShowCountDown() {
        clearInterval(this.show_timer);
        this.show_timer = null;
    }

    // 设置出现倒计时
    showCountDown() {
        if(this.show_timer != null) {
            this.time_show -= 4;
            return
        }
        this.show_timer = setInterval(() => {
            console.log(`红包出现倒计时=============>${this.showCount - this.time_show}`)
            if (this.time_show == this.showCount) {
                this.enter();
                this.hasShow = true;//红包已出现
                this.sendCount(this.pvurl);
                clearInterval(this.show_timer);
                this.show_timer = null;
            }
            this.time_show++;
        }, 1000);
    }


}

Events.mixTo(AdMoney);
export default AdMoney





// WEBPACK FOOTER //
// ./app/modules/adMoney/index.js